<template>
  <div class="c-box">
    <div>
      <div class="flex align-items-center">
        <img class="img-box" src="../../assets/images/img44.png" alt="" />
        <span class="text1">申报时间设置</span>
      </div>
      <div class="time-compontent">
        <div>
          <a-range-picker
            :show-time="{ format: 'HH:mm' }"
            format="YYYY-MM-DD HH:mm"
            @change="onChange"
            @ok="onOk"
            :disabled="isRanagePickerDisabled"
            v-model="currentTime"
            :locale="locale"
          />
        </div>
      </div>
      <div class="flex flex-center position">
        <div class="btn-box flex flex-between">
          <div v-if="isDisabled" class="btn border-btn" @click="editTime">
            编辑
          </div>
          <div v-else class="btn bg-btn" @click="selectTimeOk">完成</div>
        </div>
      </div>
    </div>
    <div>
      <div class="flex align-items-center">
        <img class="img-box" src="../../assets/images/img44.png" alt="" />
        <span class="text1">学校申报数量设置</span>
      </div>
      <div class="table-box">
        <a-table
          style="text-align: center; position: relative"
          :columns="columns"
          :data-source="data"
          :bordered="true"
          @change="changeinput1()"
          :pagination="false"
          :locale="{ emptyText: '暂无数据' }"
        >
          <template slot="sequenceNumber" slot-scope="text, record, index">
            {{ index + 1 }}
          </template>
          <span slot="schoolName" style="color: #73593b"> 学校 </span>
          <div
            slot="schoolName1"
            slot-scope="text"
            class="schoolName1"
            :title="text"
            style="color: #383838"
          >
            {{ text }}
          </div>
          <div
            slot="szStudio"
            style="color: #73593b"
            class="flex flex-col flex-center align-items-center"
          >
            <span>教学能力大赛 </span>
            <div style="width: 100%">
              <!-- <input
                style="color: #73593b"
                type="text"
                :value="szNum"
                disabled
              /> -->
              <editable-cell
                :text="szNum"
                @change="onCellChangeTitle('1', 'name', $event)"
              />
            </div>
          </div>
          <template slot="szStudio1" slot-scope="text, record, row">
            <!-- {{ record }} -->
            <editable-cell
              v-if="editableShow"
              :text="
                record.schoolMaxNums &&
                record.schoolMaxNums.length != 0 &&
                record.schoolMaxNums.filter((item) => item.applyType == 1)
                  .length != 0 &&
                record.schoolMaxNums.filter((item) => item.applyType == 1)[0]
                  .maxNum + ''
                  ? record.schoolMaxNums.filter(
                      (item) => item.applyType == 1
                    )[0].maxNum + ''
                  : '0'
              "
              @change="onCellChange(record, 'name', $event, row, '1')"
            />
          </template>
          <div
            slot="educationalBrand"
            style="color: #73593b"
            class="flex flex-col flex-center align-items-center"
          >
            <span> 各班主任工作室建设组 </span>
            <div style="width: 100%">
              <editable-cell
                :text="szNum"
                @change="onCellChangeTitle('2', 'name', $event)"
              />
            </div>
          </div>
          <template slot="educationalBrand1" slot-scope="text, record, row">
            <!-- {{record}} -->
            <editable-cell
              v-if="editableShow"
              :text="
                record.schoolMaxNums &&
                record.schoolMaxNums.filter((item) => item.applyType == 2)
                  .length != 0 &&
                record.schoolMaxNums.filter((item) => item.applyType == 2)[0]
                  .maxNum + ''
                  ? record.schoolMaxNums.filter(
                      (item) => item.applyType == 2
                    )[0].maxNum + ''
                  : '0'
              "
              @change="onCellChange(record, 'name', $event, row, '2')"
            />
          </template>
					 <div
            slot="alApply"
            style="color: #73593b"
            class="flex flex-col flex-center align-items-center"
          >
            <span> 网络育人创新联盟 </span>
            <div style="width: 100%">
              <editable-cell
                :text="szNum"
                @change="onCellChangeTitle('4', 'name', $event)"
              />
            </div>
          </div>
          <template slot="alApply1" slot-scope="text, record, row">
            <!-- {{record}} -->
            <editable-cell
              v-if="editableShow"
              :text="
                record.schoolMaxNums &&
                record.schoolMaxNums.filter((item) => item.applyType == 4)
                  .length != 0 &&
                record.schoolMaxNums.filter((item) => item.applyType == 4)[0]
                  .maxNum + ''
                  ? record.schoolMaxNums.filter(
                      (item) => item.applyType ==4
                    )[0].maxNum + ''
                  : '0'
              "
              @change="onCellChange(record, 'name', $event, row, '4')"
            />
          </template>
           <!-- <div
            slot="xal"
            style="color: #73593b"
            class="flex flex-col flex-center align-items-center"
          >
            <span> 典型小案例申报 </span>
            <div style="width: 100%">
              <editable-cell
                :text="szNum"
                @change="onCellChangeTitle('1', 'name', $event)"
              />
            </div>
          </div>
          <template slot="xal1" slot-scope="text, record, row">
            <editable-cell
              v-if="editableShow"
              :text="
                record.schoolMaxNums &&
                record.schoolMaxNums.filter((item) => item.applyType == 1)
                  .length != 0 &&
                record.schoolMaxNums.filter((item) => item.applyType == 1)[0]
                  .maxNum + ''
                  ? record.schoolMaxNums.filter(
                      (item) => item.applyType ==1
                    )[0].maxNum + ''
                  : '0'
              "
              @change="onCellChange(record, 'name', $event, row, '1')"
            />
          </template> -->
<!--          <div-->
<!--            slot="szMicroClass"-->
<!--            style="color: #73593b"-->
<!--            class="flex flex-col flex-center align-items-center"-->
<!--          >-->
<!--            <span> 思政微课 </span>-->
<!--            <div style="width: 100%">-->
<!--              <editable-cell-->
<!--                :text="szNum"-->
<!--                @change="onCellChangeTitle('3', 'name', $event)"-->
<!--              />-->
<!--            </div>-->
<!--          </div>-->
<!--          <template slot="szMicroClass1" slot-scope="text, record, row">-->
<!--            <editable-cell-->
<!--              v-if="editableShow"-->
<!--              :text="-->
<!--                record.schoolMaxNums &&-->
<!--                record.schoolMaxNums.length != 0 &&-->
<!--                record.schoolMaxNums.filter((item) => item.applyType == 3)-->
<!--                  .length != 0 &&-->
<!--                record.schoolMaxNums.filter((item) => item.applyType == 3)[0]-->
<!--                  .maxNum + ''-->
<!--                  ? record.schoolMaxNums.filter(-->
<!--                      (item) => item.applyType == 3-->
<!--                    )[0].maxNum + ''-->
<!--                  : '0'-->
<!--              "-->
<!--              @change="onCellChange(record, 'name', $event, row, '3')"-->
<!--            />-->
<!--          </template>-->
        </a-table>
      </div>
    </div>
  </div>
</template>

<script>
const EditableCell = {
  template: `
      <div class="editable-cell">
        <div v-if="editable" class="editable-cell-input-wrapper">
          <a-input :value="value" type="number" @change="handleChange($event)" @pressEnter="check" /><a-icon
            type="check"
            class="editable-cell-icon-check"
            @click="check"
            @input="handleChange($event)"
          />


        </div>
        <div v-else class="editable-cell-text-wrapper">
          {{ value || ' ' }}
          <a-icon type="edit" class="editable-cell-icon" @click="edit" />
        </div>
      </div>
    `,
  props: {
    text: String,
  },
  data() {
    return {
      value: this.text,
      editable: false,
    };
  },
  methods: {
    handleChange(e) {
      var value = JSON.parse(JSON.stringify(e.target.value));
      var flag = /^([0-9]{1,2}|100)$/.test(value);
      if (!flag) {
        value = value.replace(
          /[\\ |\\~|\\`|\\!|\\@|\\#|\\$|\\%|\\^|\\&|\\*|\\(|\\)|\-|\\_|\\+|\\=|\\||\\|\\[|\]|\\{|\\}|\\;|\\:|\\"|\\'|\\,|\\<|\\.|\\>|\\/|\\y?]/g,
          ""
        );
        if (value > 100) {
          value = 100;
        }
      }
      this.value = value;
      this.$forceUpdate();
    },
    check() {
      this.editable = false;
      this.$emit("change", this.value);
    },
    edit() {
      this.editable = true;
    },
  },
};
import {
  userLxApplyDateView,
  userLxApplyDateSet,
  schoolNumList,
  schoolNumSet,
} from "../../api/index";
import zh_CN from "ant-design-vue/lib/locale-provider/zh_CN";
import locale from "ant-design-vue/es/date-picker/locale/zh_CN";
import moment from "moment";
import "moment/locale/zh-cn";
moment.locale("zh-cn");
export default {
  name: "",
  props: {},
  data() {
    return {
      zh_CN,
      locale,
      isDisabled: true,
      isRanagePickerDisabled: true,
      currentTime: [],
      startTime: "",
      endTime: "",
      columns: [
        {
          title: "序号",
          dataIndex: "sequenceNumber",
          id: "sequenceNumber",
          align: "center",
          scopedSlots: { customRender: "sequenceNumber" },
          width:100
        },
        {
          dataIndex: "realname",
          key: "realname",
          align: "center",
          slots: { title: "schoolName" },
          scopedSlots: { customRender: "schoolName1" },
        },
        {
          dataIndex: "szStudio",
          key: "szStudio",
          align: "center",
          scopedSlots: { customRender: "szStudio1", title: "szStudio" },
          width: 200,
        },
        {
          dataIndex: "educationalBrand",
          key: "educationalBrand",
          align: "center",
          slots: { title: "educationalBrand" },
          scopedSlots: { customRender: "educationalBrand1" },
          width: 200,
        },
        // {
        //   dataIndex: "szMicroClass",
        //   key: "szMicroClass",
        //   align: "center",
        //   slots: { title: "szMicroClass" },
        //   scopedSlots: { customRender: "szMicroClass1" },
        //   width: 200,
        // },
      ],
      columns1: [
        {
          title: "序号",
          dataIndex: "sequenceNumber",
          id: "sequenceNumber",
          align: "center",
          scopedSlots: { customRender: "sequenceNumber" },
          width:100
        },
        {
          dataIndex: "realname",
          key: "realname",
          align: "center",
          slots: { title: "schoolName" },
          scopedSlots: { customRender: "schoolName1" },
        },
        {
          dataIndex: "alApply",
          key: "alApply",
          align: "center",
          slots: { title: "alApply" },
          scopedSlots: { customRender: "alApply1" },
          width: 200,
        },
        // {
        //   dataIndex: "xal",
        //   key: "xal",
        //   align: "center",
        //   slots: { title: "xal" },
        //   scopedSlots: { customRender: "xal1" },
        //   width: 200,
        // },
      ],
      data: [
        {
          key: "1",
          schoolName: "学校1",
          szStudio: "1",
          educationalBrand: "5",
          szMicroClass: "20",
          disabled: true,
        },
        {
          key: "2",
          schoolName: "学校2",
          szStudio: "1",
          educationalBrand: "5",
          szMicroClass: "30",
          disabled: true,
        },
        {
          key: "3",
          schoolName: "学校3",
          szStudio: "1",
          educationalBrand: "5",
          szMicroClass: "20",
          disabled: true,
        },
      ],
      szNum: "1",
      tsNum: "5",
      wkNum: "20",
      editableShow: true,
    };
  },
  computed: {},
  watch: {},
  components: {
    EditableCell,
  },
  created() {
  	if(this.$store.state.region=='5'){
  		this.columns=this.columns1;
  	}
  },
  mounted() {
    this.reportTime();
    this.getList();
  },
  methods: {
    getList() {
      schoolNumList().then((res) => {
        if (res.code == 200) {
          this.editableShow = false;
          this.data = res.result;
          this.$nextTick(() => {
            this.editableShow = true;
          });
        }
      });
    },
    //日期时间选择器代码
    onChange(value, dateString) {
      //选择的开始时间
      this.startTime = new Date(dateString[0]).getTime();
      this.endTime = new Date(dateString[1]).getTime();
    },
    onOk(value) {
      console.log("onOk: ", value);
    },
    changeinput1() {},
    //  编辑时间
    editTime() {
      this.isRanagePickerDisabled = false;
      this.isDisabled = false;
    },
    // 时间选择完成
    selectTimeOk() {
      let obj = {
        startTime: this.startTime,
        endTime: this.endTime,
      };
      userLxApplyDateSet(obj).then((res) => {
        if (res.code == 200) {
          this.$message.success("保存成功");
        }
      });
      this.isRanagePickerDisabled = true;
      this.isDisabled = true;
    },
    //获取上报时间
    reportTime() {
      userLxApplyDateView().then((res) => {
        let data = res.result;
        if (res.code == 200) {
          if (data.startTime !== undefined && data.endTime !== undefined) {
            this.startTime = data.startTime;
            this.endTime = data.endTime;
            this.currentTime = [
              moment(this.formatTime(this.startTime)),
              moment(this.formatTime(this.endTime)),
            ];
          } else {
            this.startTime = "开始时间";
            this.endTime = "结束时间";
            this.currentTime = [moment(this.endTime), moment(this.startTime)];
          }
        }
      });
    },
    //时间转换成日期
    formatTime(data) {
      var date = new Date(Number(data));
      var Y = date.getFullYear() + "-";
      var M =
        (date.getMonth() + 1 < 10
          ? "0" + (date.getMonth() + 1)
          : date.getMonth() + 1) + "-";
      var D =
        (date.getDate() < 10 ? "0" + date.getDate() : date.getDate()) + " ";
      var h =
        (date.getHours() < 10 ? "0" + date.getHours() : date.getHours()) + ":";
      var m =
        date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes();
      return Y + M + D + h + m;
    },
    onCellChange(key, dataIndex, value, row, column) {
      const data = {
        applyType: column,
        maxNum: value,
        schoolUserId: key.schoolUserId,
      };
      schoolNumSet(data).then((res) => {
        if (res.code == 200) {
          this.getList();
          this.$message.success("修改成功");
        } else {
          this.$message.error(res.message);
        }
      });
    },
    onCellChangeTitle(key, dataIndex, value) {
      const data = {
        applyType: key,
        maxNum: value,
        all: true,
      };
      schoolNumSet(data).then((res) => {
        if (res.code == 200) {
          this.getList();
          this.$forceUpdate();
          this.$message.success("修改成功");
        } else {
          this.$message.error(res.message);
        }
      });
    },
  },
};
</script>

<style scoped lang="scss">
span input {
  border: none;
  background: #f7f7f7;
  text-align: center;
  color: #383838;
}
.c-box {
  height: 100%;
  // max-height: 640px;
  overflow: auto;
}
.img-box {
  width: 19px;
  height: 19px;
  margin-right: 8px;
}
.text1 {
  font-size: 18px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #383838;
}
.time-compontent {
  margin: 10px 0 15px 20px;
  position: relative;
}
.position {
  position: absolute;
  top: 19px;
  left: 440px;
}
.table-box {
  padding: 30px 15px 15px 15px;
}

.btn-box {
  margin-top: 30px;
  width: 242px;
  height: 40px;
}
.btn {
  width: 116px;
  height: 35px;
  line-height: 35px;
  text-align: center;
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  border-radius: 10px;
  cursor: pointer;
}
.border-btn {
  border: 1px solid #9A0B00;
  color: #9A0B00;
}
.bg-btn {
  color: #fff;
  background: #9A0B00;
}
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
}
input[type="number"] {
  -moz-appearance: textfield;
}
/deep/ .ant-table-header-column {
  width: 100%;
}
/deep/ .ant-table-align-center {
  position: relative;
}
/deep/ .editable-cell-icon-title {
  position: absolute;
  right: 5%;
  top: 50%;
  transform: translate(0%, 30%);
}
/deep/ .editable-cell {
  position: relative;
}

/deep/ .editable-cell-input-wrapper,
/deep/ .editable-cell-text-wrapper {
  padding-right: 24px;
}

/deep/ .editable-cell-text-wrapper {
  padding: 5px 24px 5px 5px;
}

/deep/ .editable-cell-icon,
/deep/ .editable-cell-icon-check {
  position: absolute;
  right: 0;
  width: 20px;
  cursor: pointer;
}

/deep/ .editable-cell-icon {
  line-height: 24px;
  display: none;
}

/deep/ .editable-cell-icon-check {
  line-height: 36px;
}

/deep/ .editable-cell:hover .editable-cell-icon {
  display: inline-block;
}

/deep/ .editable-cell-icon:hover,
/deep/ .editable-cell-icon-check:hover {
  color: #108ee9;
}

/deep/ .editable-add-btn {
  margin-bottom: 8px;
}
/deep/ input::-webkit-outer-spin-button,
/deep/ input::-webkit-inner-spin-button {
  -webkit-appearance: none;
}

/deep/ input[type="number"] {
  -moz-appearance: textfield;
}
.schoolName1 {
  width: 350px;

  margin: 0 auto;
}
</style>
